<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="workLineInfoes"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editWorkLineInfo.open(0)">新建</el-button>
        <el-button type="danger" @click="deleteIds">批量删除</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="产线名称">
            <el-input v-model.trim="filter.cname" clearable/>
          </vm-search>
          <vm-search label="编号">
            <el-input v-model.trim="filter.code" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="cname" align="center" label="产线名称"/>
      <el-table-column prop="code" align="center" label="编号"/>
      <el-table-column prop="addDate" align="center" label="添加日期"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editWorkLineInfo.open(scope.row.pkid)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <work-line-info-edit ref="editWorkLineInfo" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import WorkLineInfoEdit from "@/views/information/WorkLineInfo/WorkLineInfoEdit";
  export default {
    name: "WorkLineInfoList",
    components: {WorkLineInfoEdit,VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          cname: "",
          code: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onNodeClick(data) {
        this.filter.keyWord = data.departmentName;
        this.getList(1);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic","workLineInfoes/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
    },
  };
</script>

<style scoped>

</style>
